/**
 * Der Reiter „Tasks" des Bestell-Drawers - Portierung von `drawerTasksTab` (`index.html:9129-9149`).
 * Er haengt sich als `children` in `.drawer-body` des Rahmens aus Task 16, wie `BestellungTab`
 * (Task 17).
 *
 * Aufbau, in der Reihenfolge des Originals:
 *
 *   sec('tasks-list', `Tasks · N offen`)
 *     .task-template-description (Notizen)     nur wenn Vorlagenbestellung ODER Notiz vorhanden
 *     PhasenListe                              die Phasen-/Aufgabenliste (`PhasenListe.tsx`)
 *     „Task hinzufügen"
 *     „Vorlage anwenden"                       KEIN Bestandsknopf - Auftrag "Task-Vorlage
 *                                               tatsaechlich anwenden" (2026-08-26), siehe dortiger
 *                                               Abschnitt weiter unten
 *   AufgabenDetail                             das Detailfenster (`AufgabenDetail.tsx`), portalt
 *                                               nach `#drawer` - siehe dessen Kopfkommentar
 *
 * `sec` ist der Port `Abschnitt` aus Task 16.
 *
 * ================= DER SCHREIBWEG, UMGESTELLT AM 2026-08-15 =====================================
 *
 * Bis hierher schrieb dieser Reiter wie der Bestand: das GANZE `tasks`-Array als EIN Feld der
 * Bestellung, ueber `onAendern(id, { tasks })`. Im Bestand war das richtig - die Bestellung war ein
 * JSON-Blob, und `permissionForOrderField` ordnete das Feld `tasks` schlicht `manage_tasks` zu
 * (`cloudflare/src/worker.ts:701`). Im neuen Modell haben die Aufgaben eine EIGENE Tabelle mit
 * eigenen Routen; `bestellungAendern` weist das Feld deshalb mit `FeldOhneGruppeFehler` ab, BEVOR
 * etwas gesendet wird. Jeder Klick auf "Task hinzufügen" endete im Toast "Die Bestellung konnte
 * nicht geändert werden." - laut, aber wirkungslos.
 *
 * Ab jetzt geht jede der fuenf Schreibstellen ueber ihre eigene Route (`api/aufgaben.ts`):
 *
 *   Anlegen        POST   /api/orders/:id/tasks
 *   Feld aendern   PATCH  /api/orders/:id/tasks/:taskId   (Titel, Beschreibung, Frist, Erledigt,
 *                                                          Zustaendigkeitsmodul)
 *   Loeschen       DELETE /api/orders/:id/tasks/:taskId
 *
 * DREI FOLGEN, die man sehen muss:
 *
 *  1. **Jede Aufgabe traegt ihre eigene `rowVersion`.** Sie kommt seit dem 2026-08-13 mit der
 *     Bestellung mit (`backend/src/domaene/orders.ts`) und wird beim Schreiben mitgeschickt. Eine
 *     Aufgabe ohne `rowVersion` ist keine gespeicherte Aufgabe - `versionVon` unten faengt das ab,
 *     statt eine Zahl zu erfinden.
 *  2. **`updatedAt`/`updatedBy` setzt der Server.** Der Bestand trug sie bei jedem Tastendruck
 *     selbst ein (`patchTask`, index.html:9172-9186); hier tut es `updateVersioned` aus dem
 *     angemeldeten Nutzer. Sie stehen deshalb in `KEIN_AUFGABEN_WEG` und werden nicht mehr
 *     mitgeschickt - die Prop `nutzer` ist damit ersatzlos entfallen.
 *  3. **Nach jedem Schreibvorgang laedt der Aufrufer die BESTELLUNG nach**, nicht die Aufgabe: die
 *     Aufgaben haengen flach am Bestellobjekt, und der Store ersetzt Datensaetze ganz. Das erledigt
 *     `App.tsx` (siehe die drei `drawerAufgabe*`-Funktionen dort), nicht dieser Reiter.
 *
 * ================= WAS WEITERHIN NICHT SCHREIBT, UND WARUM =====================================
 *
 * `taskPhaseDetails` (die Phasenangaben: eigener Name, eigene Beschreibung einer Phase - zu sehen im
 * Detailfenster nach "Phase öffnen") hat eine Tabelle - `order_task_phase_details`
 * (005_domaene.sql:185) - aber KEINE Route; im ganzen `backend/src/http` gibt es keinen Treffer fuer
 * `phase_details`. Ein Klick darauf koennte also nur scheitern. Statt ihn weiter still scheitern zu
 * lassen, sind die betroffenen Bedienelemente (Name, Beschreibung, Zuweisung, Frist der Phase SELBST
 * im Detailfenster - nicht ihrer einzelnen Tasks) SICHTBAR gesperrt (`PHASEN_SCHREIBEN_GESPERRT`
 * unten, an `AufgabenDetail` durchgereicht) - dieselbe Haltung wie beim Spalteneditor ohne
 * `manage_settings` in `App.tsx`: lieber ein sichtbar gesperrtes Feld als eines, das bedienbar
 * aussieht und nichts tut.
 *
 * Die Erledigt-Umschaltung EINER Aufgabe ist davon nicht betroffen - sie geht ueber `order_tasks`
 * und wirkt, wie schon zuvor. SEIT AUFTRAG "Meilensteine (Phasen) im Tasks-Tab abhakbar machen"
 * (2026-08-28) gilt das auch fuer „ganze Phase erledigen": die Checkbox der Phasen-Kopfzeile
 * (`.task-phase-check`, `PhasenListe.tsx#TaskPhaseBlock`) schreibt jetzt ueber die eigene Route
 * `PATCH /api/orders/:id/tasks/bulk-done` ALLE Tasks der Gruppe auf einmal (`onPhaseErledigt` unten,
 * `api/aufgaben.ts#aufgabenBulkErledigen`) - sie setzt `order_tasks.done` mehrerer Zeilen, NICHT
 * `taskPhaseDetails`. `PHASEN_SCHREIBEN_GESPERRT` reicht deshalb NICHT MEHR an `PhasenListe` durch,
 * nur noch an `AufgabenDetail` (fuer die weiterhin ungeschriebenen Phasenangaben selbst). NACHBESSERUNG
 * (Pruefer-Befund 2): die ZWEITE "Phase erledigt"-Checkbox - im Detailfenster nach "Phase öffnen",
 * `AufgabenDetail.tsx` - trug bis dahin trotzdem noch `disabled={phasenGesperrt}`, obwohl auch sie nur
 * `order_tasks.done` schreibt. Sie nutzt jetzt denselben Bulk-Weg wie `.task-phase-check` oben (siehe
 * `AufgabenDetail.tsx`, Prop `onPhaseErledigt`) und ist ebenfalls nicht mehr an `phasenGesperrt` gebunden.
 *
 * ================= `TASK_DETAIL_VIEW` als lokaler State statt Modul-Global ====================
 *
 * Der Bestand haelt `TASK_DETAIL_VIEW` als Modul-Global (`index.html:4593`), setzt es aber an JEDER
 * Stelle, die eine andere Bestellung oeffnet oder den Tab wechselt, explizit auf `null` zurueck
 * (`openDrawer` bei `openId !== id`: `:9248`; `gotoTab`: `:8382`; `closeDrawer`: `:9633`). Es
 * ueberlebt also NIE einen Tab- oder Bestellwechsel - anders als `SEC_COLLAPSED`/`TASK_PHASE_
 * COLLAPSED`, die pro SITZUNG gelten. Ein React-`useState` in dieser Komponente bildet das exakt
 * nach: `TasksTab` wird beim Tabwechsel neu gemountet (der Elternbaum zeichnet je Tab genau eine
 * Reiterkomponente), ein frisches `useState(null)` entspricht darum von selbst dem Zustand nach
 * `gotoTab`/`closeDrawer`. Fuer den Bestellwechsel INNERHALB desselben Mounts (Board-Zeile fuer
 * Bestellung B anklicken, waehrend der Tasks-Reiter fuer Bestellung A offen war) fehlt diese
 * automatische Ruecksetzung - deshalb der explizite `useEffect` unten, der `id` beobachtet.
 *
 * SEIT AUFGABE 6 (Tieflinks, § 3.8) GILT DAS NUR NOCH FUER `neueId`: die Aufgabenauswahl selbst ist
 * kein `useState` mehr, sondern aus der ADRESSE abgeleitet (siehe der Kommentar direkt an
 * `useAnsicht()` unten). Der Bestellwechsel braucht dafuer keine eigene Ruecksetzung mehr - `kennung`
 * und `aufgabe` stehen im selben `Ansicht.bestellung`-Objekt und wechseln deshalb IMMER gemeinsam.
 *
 * ================= DIE ZUSTAENDIGKEITSMODULE LAEDT DIESER REITER SELBST ========================
 *
 * Bis hierher bekam er sie als Prop von `App.tsx` - aus der Aufgaben-VORLAGE (`taskVorlagenModule`,
 * `task_templates.responsibilityModules`). Das ist die Modulform des BESTANDS: die `id` ist dort
 * `"responsibility_purchasing"`, ein sprechender Alt-Schluessel. `order_tasks.responsibility_id` ist
 * dagegen ein uuid-Fremdschluessel auf `responsibility_modules` (005_domaene.sql:168). Diese Ids in
 * einen PATCH zu geben ergaebe SQLSTATE 22P02 und damit einen 500 - die Auswahl waere bedienbar und
 * kaputt.
 *
 * Die echten Module kommen deshalb ueber `moduleLaden()` (`api/zustaendigkeitsModule.ts`,
 * `GET /api/responsibility-modules`, ohne Rechtevorbehalt). Derselbe Weg, den `TaskTemplate/
 * VorlagenDialog.tsx` schon benutzt - kein neues Muster, und bewusst KEIN Speicherfeld: die Liste
 * hat vier Zeilen, ist unveraenderlich (weder POST noch DELETE) und wird nur hier und dort gebraucht.
 *
 * SCHEITERT DAS LADEN, bietet die Auswahl nur "Kein Modul" an - das sah bis Fehleranzeige Paket 2
 * (Task 8) aus wie "es gibt keine Module". Jetzt meldet der Reiter es im Fehlerstapel
 * (`meldeFehler(ursache, MODULE_LADEN_SATZ)`, Regel L2: die Module haben keine eigene Flaeche, also
 * kein Text im Reiter). Der Satz steht in `../moduleLadenSatz.ts`, weil `SammelsendungDrawer.tsx` dieselben
 * Module laedt: scheitert beides gleich, wird im Stapel EIN Eintrag mit Zaehler daraus.
 *
 * ================= "VORLAGE ANWENDEN" (Auftrag "Task-Vorlage tatsaechlich anwenden", 2026-08-26) ===
 *
 * `VorlagenDialog.tsx` fuehrte bis zu diesem Auftrag als BENANNTE Luecke (Kopfkommentar dort,
 * Luecke b): "AUS DER VORLAGE ENTSTEHEN HEUTE KEINE AUFGABEN" - `POST /api/orders` legte keine Tasks
 * an, und im Tasks-Reiter gab es keinen Weg, das nachzuholen. Beides schliesst dieser Auftrag:
 * `legeBestellungAn()` (backend/src/domaene/orders.ts) wendet die aktive Vorlage seither AUTOMATISCH
 * bei jeder Bestellanlage an; der Knopf hier ist der MANUELLE Weg fuer bereits bestehende
 * Bestellungen - z. B. nachdem die Vorlage um Zeilen ergaenzt wurde, oder fuer die 30 Bestellungen,
 * die vor diesem Auftrag entstanden sind (`backend/src/betrieb/vorlageBackfill.ts`, einmaliger
 * Nachholbedarf, nicht Teil dieses Reiters).
 *
 * KEINE EIGENE RECHTEPRUEFUNG: der Knopf ist ein `<button>` in `.drawer-body` wie "Task hinzufügen"
 * daneben - der zentrale Rechte-Durchgang des Rahmens (`Drawer.tsx`) sperrt beide gemeinsam ohne
 * `manage_tasks` (`DRAWER_TAB_EDIT_PERMISSIONS.tasks`, `drawerRechte.ts`). Eine zweite, lokale
 * `hatRecht(...)`-Pruefung waere eine zweite Rechtequelle, die mit der ersten auseinanderlaufen kann.
 */
import { useEffect, useMemo, useState } from "react";
import { Abschnitt } from "../Abschnitt.tsx";
import { AufgabenDetail } from "./AufgabenDetail.tsx";
import { AufgabenKontextMenue } from "./AufgabenKontextMenue.tsx";
import { PhasenListe, aufgabenPhasenGruppen, istVorlagenBestellung } from "./PhasenListe.tsx";
import type { AufgabenAnsicht } from "./AufgabenDetail.tsx";
import { useAnsicht } from "../../../state/useAnsicht.ts";
import { moduleLaden } from "../../../api/zustaendigkeitsModule.ts";
import type { Zustaendigkeitsmodul } from "../../../api/zustaendigkeitsModule.ts";
import { todayIso } from "../../../lib/format.ts";
import { meldeFehler } from "../../../state/fehlerStapel.ts";
import { MODULE_LADEN_SATZ } from "../moduleLadenSatz.ts";
import type { Order, OrderTask } from "../../../lib/types.ts";
import { feldZustandClass } from "../../../utils/feldZustand.ts";

/**
 * `icon(name, className)` (`index.html:4016`) samt der Nachbearbeitung durch `hydrateIcons`
 * (`:4021`) - die gemeinsame Registratur zeichnet das fertige `<svg class="lucide lucide-…">`.
 *
 * Bis `feat/09-spa-ikonen` stand hier eine LOKALE Funktion, die nur den Platzhalter
 * `<i data-lucide="…">` erzeugte. Den hydriert in der SPA niemand (die UMD-Fassung laeuft allein
 * im Baseline-Rundlauf des Playwright-Harness) - es blieb eine leere Flaeche. Siehe `Ikone.tsx`.
 */
import { Ikone } from "../../Ikone.tsx";

/**
 * Der Vorgabetitel einer frisch angelegten Aufgabe.
 *
 * ABWEICHUNG VOM BESTAND, und sie ist erzwungen: `addTask` legt mit `name: ''` an
 * (index.html:9161) und laesst den Nutzer den Namen danach im Detailfenster eintippen. Hier geht das
 * nicht - `order_tasks.title` ist NOT NULL, und `POST /api/orders/:id/tasks` weist einen leeren
 * Titel mit 400 ab (`taskAnlegenAusKoerper`). Die Aufgabe bekommt deshalb einen Vorgabetitel, und
 * das Detailfenster oeffnet sich wie im Bestand sofort darueber - der erste Tastendruck ersetzt ihn.
 *
 * Der Wortlaut ist derselbe, den `PhasenListe.tsx` bisher als Rueckfall fuer eine namenlose Aufgabe
 * zeichnete (`{(aufgabe.name as string) || "Neue Aufgabe"}`) - im Ergebnis sieht der Nutzer also
 * genau das, was er vorher auch sah, nur steht es jetzt wirklich in der Zeile.
 */
export const NEUE_AUFGABE_TITEL = "Neue Aufgabe";

/**
 * Tooltip fuer das Notizenfeld (`taskTemplateDescription`) - strukturell gesperrt, siehe
 * Kopfkommentar zu `.task-template-description` unten. Woertlich aus `feldzustand-spec.md`, Tabelle
 * "Gesperrt", exakt uebernommen - keine eigene Formulierung. Ersetzt den bisherigen `title`
 * `"Für dieses Feld gibt es keine Spalte - siehe KEIN_FELDGRUPPEN_WEG"`: der ist ausserhalb dieses
 * einen `title`-Attributs nirgends referenziert (kein Test, kein zweiter Aufrufer - gepruefte
 * Recherche), die Begruendung mit `KEIN_FELDGRUPPEN_WEG` bleibt unveraendert im umgebenden
 * Kopfkommentar stehen.
 */
const NOTIZEN_GESPERRT_TITEL = "Für dieses Feld gibt es aktuell keine Speicherspalte.";

/**
 * Ob die PHASENANGABEN SELBST (Name, Beschreibung im Detailfenster einer Phase, `taskPhaseDetails`)
 * gesperrt sind - heute IMMER, siehe Kopfkommentar "Was weiterhin nicht schreibt". Eine benannte
 * Konstante und kein `true` an mehreren Stellen im JSX: wer die Route baut, findet hier den einen
 * Ort, an dem sie ausgeht, und stolpert ueber die Begruendung.
 *
 * SEIT AUFTRAG "Meilensteine (Phasen) im Tasks-Tab abhakbar machen" (2026-08-28) geht diese
 * Konstante NICHT MEHR an `PhasenListe`: die Checkbox „ganze Phase erledigen" ist kein Teil von
 * `taskPhaseDetails` mehr betroffen - sie schreibt `order_tasks.done` mehrerer Zeilen ueber
 * `onPhaseErledigt` unten und folgt fuer ihr `disabled` derselben Quelle wie jede einzelne
 * Task-Checkbox (der Rechte-Durchgang des Rahmens, siehe `PhasenListe.tsx`). Sie bleibt nur noch an
 * `AufgabenDetail` durchgereicht (Name/Beschreibung/Zuweisung/Frist einer Phase SELBST).
 */
const PHASEN_SCHREIBEN_GESPERRT = true;

export interface TasksTabProps {
  bestellung: Order;
  /** Ungenutzt - siehe Kopfkommentar „Rechte" (wie `BestellungTabProps.rechte`). */
  rechte: ReadonlySet<string>;
  /**
   * `POST /api/orders/:id/tasks` - der Aufrufer laedt danach die Bestellung nach und meldet die
   * angelegte Aufgabe ueber `beiErfolg`. Ohne diese Rueckmeldung liesse sich das Detailfenster nicht
   * oeffnen: welchen PLATZ die neue Aufgabe in der Liste hat, weiss erst der Server (`sort_index`).
   */
  onAufgabeAnlegen: (
    bestellungId: string,
    aufgabe: { title: string },
    beiErfolg: (neu: OrderTask) => void,
  ) => void;
  /** `PATCH /api/orders/:id/tasks/:taskId` - `aenderung` in der Form der Oberflaeche (`name`, …). */
  onAufgabeAendern: (
    bestellungId: string,
    aufgabe: OrderTask,
    aenderung: Record<string, unknown>,
  ) => void;
  /** `DELETE /api/orders/:id/tasks/:taskId`. */
  onAufgabeLoeschen: (bestellungId: string, aufgabe: OrderTask) => void;
  /**
   * Auftrag "Tasks Sammelbearbeitung" (2026-09-04, Anforderung Damian Gembries): das Sammel-Loeschen
   * hinter dem Kontextmenue-Eintrag "Löschen ({N} Aufgaben)" (`AufgabenKontextMenue.tsx`). KEIN
   * Bulk-Backend-Endpoint (`backend/src/http/routes/orderTasks.ts` kennt nur eine `taskId` je
   * Aufruf) - der Aufrufer (`App.tsx#drawerAufgabenSammelLoeschen`) ruft `DELETE .../tasks/:taskId`
   * fuer JEDE mitgegebene Aufgabe einzeln (Muster wie `sammelStatusAendern`s Board-Pendant, hier
   * ohne dessen Mehrbestellungs-Komplexitaet: alle Aufgaben haengen an DERSELBEN Bestellung, ein
   * einziges Nachladen am Ende genuegt). Optional - ein isolierter
   * Komponententest dieses Reiters (ohne `App.tsx`) kommt ohne sie aus, solange er die
   * Sammel-Loeschung selbst nicht ausloest.
   */
  onAufgabenSammelLoeschen?: (bestellungId: string, aufgaben: OrderTask[]) => void;
  /**
   * `PATCH /api/orders/:id/tasks/bulk-done` (Auftrag "Meilensteine (Phasen) im Tasks-Tab abhakbar
   * machen") - setzt `done` fuer ALLE mitgeschickten `taskIds` einer Phasengruppe auf einmal, der
   * Schreibweg hinter `.task-phase-check` (`PhasenListe.tsx#TaskPhaseBlock`). Wie
   * `onAufgabeAendern`/`-Loeschen`/`-Anlegen` laedt der Aufrufer danach die Bestellung nach - es gibt
   * keinen separaten "erfolgreich"-Rueckruf, der Store ersetzt die Bestellung ohnehin ganz.
   */
  onPhaseErledigt: (bestellungId: string, taskIds: string[], erledigt: boolean) => void;
  /**
   * `POST /api/orders/:id/tasks/vorlage-anwenden` (Auftrag "Task-Vorlage tatsaechlich anwenden") -
   * der manuelle Anwendungsweg neben der automatischen Anwendung bei Bestellanlage
   * (`legeBestellungAn`, backend/src/domaene/orders.ts). Der Aufrufer legt die noch fehlenden
   * Vorlagen-Tasks an, laedt die Bestellung nach und meldet per Toast, wie viele es waren - `0` ist
   * ein gueltiges Ergebnis (die Vorlage war bereits vollstaendig angewendet).
   *
   * Liefert (anders als `onAufgabeAnlegen`/`-Aendern`/`-Loeschen`) eine Promise, die IMMER aufgeloest
   * wird (nie ablehnt - `App.tsx#drawerVorlageAnwenden` faengt jeden Fehler selbst) - der Reiter
   * haelt daran seine eigene `wirdAngewendet`-Sperre (Review-Befund, In-Flight-Sperre am Knopf,
   * dasselbe Muster wie `speichert` in `VorlagenDialog.tsx`).
   */
  onVorlageAnwenden: (bestellungId: string) => Promise<void>;
}

export function TasksTab({
  bestellung: o,
  onAufgabeAnlegen,
  onAufgabeAendern,
  onAufgabeLoeschen,
  onAufgabenSammelLoeschen,
  onPhaseErledigt,
  onVorlageAnwenden,
}: TasksTabProps) {
  const id = o.id as string;
  const tasks = (o.tasks as OrderTask[] | undefined) || [];
  // Fixrunde 1, Befund W-3: `tasks.length === 0` allein unterscheidet NICHT "die Bestellung ist noch
  // nicht aufgeloest" (o.tasks === undefined) von "die Bestellung hat wirklich keine Aufgaben"
  // (o.tasks === []). Beides fiel bisher unter dieselbe Wartepflicht - eine echte, tote Aufgaben-
  // kennung an einer taskleeren Bestellung meldete sich NIE (§ 5.4 blieb stumm).
  const tasksGeladen = o.tasks !== undefined;
  const heute = todayIso();
  const [module, setModule] = useState<readonly Zustaendigkeitsmodul[]>([]);
  /** Id einer gerade angelegten Aufgabe, deren Detail noch zu oeffnen ist - siehe `aufgabeHinzufuegen`. */
  const [neueId, setNeueId] = useState<string | null>(null);
  /**
   * In-Flight-Sperre fuer "Vorlage anwenden" (Review-Befund, KRITISCH-Begleitfund Runde 3) - dasselbe
   * Muster wie `speichert` in `VorlagenDialog.tsx`: verhindert den Doppelklick-Fall bereits auf
   * Client-Seite, zusaetzlich zur serverseitigen Zeilensperre (`domaene/tasks.ts`, `SELECT ... FOR
   * UPDATE`). Zurueckgesetzt ueber `useEffect([id])` unten wie `neueId` - ein Bestellwechsel WAEHREND
   * eine Anwendung noch laeuft, soll den Knopf der NEUEN Bestellung nicht faelschlich gesperrt zeigen.
   */
  const [wirdAngewendet, setWirdAngewendet] = useState(false);

  /**
   * Auftrag "Tasks Sammelbearbeitung" (2026-09-04, Anforderung Damian Gembries: "bekommen wir das
   * auch fuer die Untertasks hin?") - dasselbe Muster wie `Board/BoardSeite.tsx`s `ausgewaehlt`/
   * `anker` (dortiger Kopfkommentar gilt woertlich auch hier): FLUECHTIGER UI-Zustand, deshalb lokal
   * und NICHT in der Adresse (anders als `ansicht`/`auswahl` oben, die einen verlinkbaren Standpunkt
   * tragen). `ausgewaehlt` haelt Task-IDS (nicht Indizes - ein Index verschiebt sich beim Loeschen,
   * dieselbe Falle wie bei `auswahl`/`ansicht` oben), `anker` die zuletzt per Strg-/Shift-Klick
   * beruehrte Id als Basis fuer den naechsten Shift-Bereich.
   */
  const [ausgewaehlt, setzeAusgewaehlt] = useState<Set<string>>(() => new Set());
  const [anker, setzeAnker] = useState<string | null>(null);

  /**
   * Auftrag "Tasks Sammelbearbeitung" - Zustand und Oeffnen/Schliessen des Kontextmenues, dasselbe
   * Muster wie `App.tsx`s `kontextmenue`/`kontextmenueOeffnen`/`kontextmenueSchliessen` fuers Board
   * (dortiger Kopfkommentar "Board: Kontextmenue" gilt sinngemaess) - hier lokal in diesem Reiter
   * statt in `App.tsx`, weil die Aufgabenliste (anders als das Board) keinen Zustand ausserhalb
   * dieser Komponente braucht.
   *
   * VOR den Escape-Effekt gezogen (Fix-Auftrag "Sammelbearbeitung, Pruefer-Befund 2", 2026-09-04):
   * dieser Effekt liest `kontextmenue` (siehe dort), ein State-Hook muss vor seiner ersten
   * Lesestelle im Funktionskoerper stehen - `kontextmenueOeffnen`/`-Schliessen`/`-Aktion` bleiben an
   * ihrer bisherigen Stelle weiter unten, sie sind reine Funktionsdefinitionen und schliessen ueber
   * `kontextmenue`/`setKontextmenue` unabhaengig von der Position.
   */
  const [kontextmenue, setKontextmenue] = useState<{
    aufgabe: OrderTask;
    index: number;
    x: number;
    y: number;
  } | null>(null);

  /**
   * Auftrag "Tasks Sammelbearbeitung": die flache, GEORDNETE Liste aller Aufgaben-Ids ueber ALLE
   * Phasengruppen hinweg - die Grundlage fuer den Shift-Bereich in `zeileAngeklickt` unten, dasselbe
   * Prinzip wie `BoardSeite.tsx#sichtbareZeilenIds`. Anders als dort gibt es hier KEINE Ausschluss-
   * menge wie `archivierteIds`: jede gerenderte Aufgabenzeile ist auswaehlbar. Eingeklappte Phasen
   * (`TASK_PHASE_COLLAPSED`, `PhasenListe.tsx`) bleiben bewusst UNBERUECKSICHTIGT - anders als eine
   * eingeklappte Board-Gruppe blendet `PhasenListe.tsx` ihre Zeilen nur per CSS aus (`.task-phase.
   * collapsed .task-phase-body`), sie stehen weiterhin im DOM. Ein Shift-Bereich ueber eine
   * eingeklappte Phase hinweg schliesst ihre Aufgaben deshalb mit ein, wie ein Bereich ueber jede
   * andere, sichtbare Phase auch.
   */
  const sichtbareAufgabenIds = useMemo(
    () =>
      aufgabenPhasenGruppen(o)
        .flatMap((gruppe) => gruppe.eintraege)
        .map((eintrag) => String(eintrag.aufgabe.id ?? ""))
        .filter((taskId) => taskId.length > 0),
    [o],
  );

  /**
   * Der VOLLE Maus-Klick-Handler einer Aufgabenzeile - ersetzt das bisherige `onClick={oeffnen}` in
   * `PhasenListe.tsx#AufgabenZeile`. Woertlich dasselbe Dreiwege-Verhalten wie `BoardSeite.tsx#
   * zeileAngeklickt` (dortiger Kopfkommentar gilt sinngemaess): Strg/Cmd togglet, Shift markiert den
   * Bereich vom Anker bis zur Zeile (ersetzt die bisherige Auswahl, kein additives Shift+Strg), ein
   * Klick ohne Zusatztaste leert die Auswahl und oeffnet die Aufgabe wie bisher.
   *
   * Eine Aufgabe OHNE `id` (frisch angelegt, siehe `NEUE_AUFGABE_TITEL`-Kommentar oben, „Risiko 7")
   * kann nicht Teil der Auswahl werden - Strg/Shift auf einer solchen Zeile bleibt wirkungslos, ein
   * einfacher Klick oeffnet sie trotzdem normal.
   */
  const zeileAngeklickt = (ereignis: React.MouseEvent, index: number): void => {
    const taskId = String(tasks[index]?.id ?? "");
    const toggeln = (menge: Set<string>): Set<string> => {
      const neu = new Set(menge);
      if (neu.has(taskId)) neu.delete(taskId);
      else neu.add(taskId);
      return neu;
    };

    if (ereignis.ctrlKey || ereignis.metaKey) {
      if (!taskId) return;
      setzeAusgewaehlt(toggeln(ausgewaehlt));
      setzeAnker(taskId);
      return;
    }

    if (ereignis.shiftKey) {
      if (!taskId) return;
      const startIdx = anker == null ? -1 : sichtbareAufgabenIds.indexOf(anker);
      const endIdx = sichtbareAufgabenIds.indexOf(taskId);
      if (startIdx < 0 || endIdx < 0) {
        setzeAusgewaehlt(toggeln(ausgewaehlt));
        setzeAnker(taskId);
        return;
      }
      const [lo, hi] = startIdx <= endIdx ? [startIdx, endIdx] : [endIdx, startIdx];
      setzeAusgewaehlt(new Set(sichtbareAufgabenIds.slice(lo, hi + 1)));
      return;
    }

    if (ausgewaehlt.size) setzeAusgewaehlt(new Set());
    setzeAnker(null);
    setAnsicht({ kind: "task", index });
  };

  // Auftrag "Tasks Sammelbearbeitung": Escape leert die Auswahl - global, wie `BoardSeite.tsx`s
  // gleichnamiger Effekt (dortiger Kopfkommentar gilt woertlich).
  //
  // NACHBESSERUNG (Fix-Auftrag "Sammelbearbeitung, Pruefer-Befund 2", 2026-09-04): die Angabe, die
  // hier bis dahin stand ("dieser Reiter kennt keinen zweiten, mit Escape schliessbaren Dialog, der
  // mit dem Leeren kollidieren koennte"), war seit Einfuehrung von `AufgabenKontextMenue` FALSCH -
  // dessen eigener, unabhaengiger Escape-Listener (siehe dort, "Schliesst bei Escape...") haengt am
  // selben `document`-`keydown` und feuert auf DENSELBEN Tastendruck. Ohne Schranke warf ein Escape
  // bei offenem Kontextmenue BEIDES gleichzeitig weg - das Menue UND die Markierung: 5 Aufgaben
  // markieren, rechtsklicken ("Löschen (5 Aufgaben)" erscheint), es sich anders ueberlegen und
  // Escape druecken sollte nur das Menue zumachen, nicht auch die muehsam gesetzte Auswahl loeschen.
  //
  // Anders als beim Board (eigene Prop `escapeAuswahlGesperrt`, von `App.tsx` gesetzt, weil die
  // Auswahl DORT in `BoardSeite` liegt, der Dialog aber in `App.tsx`) reicht hier eine lokale
  // Abhaengigkeit: `kontextmenue` lebt in DIESER Komponente (siehe dessen Kopfkommentar oben, neben
  // `ausgewaehlt`/`anker`). Solange es gesetzt ist, tut dieser Effekt NICHTS - das Menue schliesst
  // sich ueber seinen eigenen Listener, die Auswahl bleibt stehen. Ein ZWEITES Escape (Menue schon
  // zu, `kontextmenue === null`) leert die Auswahl wie zuvor.
  useEffect(() => {
    const beiTaste = (ereignis: KeyboardEvent): void => {
      if (ereignis.key !== "Escape" || !ausgewaehlt.size || kontextmenue) return;
      setzeAusgewaehlt(new Set());
    };
    document.addEventListener("keydown", beiTaste);
    return () => document.removeEventListener("keydown", beiTaste);
  }, [ausgewaehlt, kontextmenue]);

  /**
   * Die Auswahl lebt in der ADRESSE, damit sich eine einzelne Aufgabe verlinken laesst
   * (Spezifikation § 3.8).
   *
   * Die URL traegt `task.id`, dieser Zustand den ARRAY-INDEX - `AufgabenDetail` und die Handler
   * darunter rechnen unveraendert mit dem Index weiter. Die Umrechnung geschieht GENAU HIER, an der
   * Grenze. Den Index in die URL zu schreiben waere der Fehler: er verschiebt sich beim Loeschen,
   * und ein verschickter Link zeigte danach still auf eine andere Aufgabe (§ 1.2).
   */
  const { ansicht: adresse, setzeAnsicht } = useAnsicht();
  const auswahl = adresse.bestellung?.aufgabe ?? null;
  const ansicht: AufgabenAnsicht = useMemo(() => {
    if (!auswahl) return null;
    if (auswahl.kind === "phase") return { kind: "phase", phaseId: auswahl.phaseId };
    const index = tasks.findIndex((a) => String(a.id ?? "") === auswahl.taskId);
    return index < 0 ? null : { kind: "task", index };
  }, [auswahl, tasks]);

  /**
   * `optionen` reicht unveraendert an `setzeAnsicht` durch (Fixrunde 1, Befund K-1): die sechs
   * normalen Setzstellen (Zeile oeffnen, Phase oeffnen, Panel schliessen, ...) bleiben ein PUSH -
   * ein "Zurueck" soll zur vorigen Auswahl zurueckfuehren, wie jede andere Navigation (§ 4). Die
   * BEREINIGUNG einer nicht mehr existierenden Auswahl ist keine Navigation in diesem Sinn, sondern
   * die Korrektur eines kaputten Standpunkts - dafuer verlangt § 5.4 ausdruecklich `{ ersetzen:
   * true }`, wie der Schwesterfall in `App.tsx` (§ 5.3, "meldet eine unbekannte Bestellung"). Ohne
   * `ersetzen` SCHOB die Bereinigung: ein "Zurueck" landete wieder auf der kaputten Adresse, der
   * Meldeeffekt feuerte erneut, ein zweiter Push entstand - die Zurueck-Taste kam nicht mehr am
   * Reiter vorbei. Gemessen, nicht vermutet (`history.length` 1 -> 2 vor dieser Fixrunde).
   */
  const setAnsicht = (neu: AufgabenAnsicht, optionen?: { ersetzen?: boolean }): void => {
    const aufgabe =
      neu === null
        ? null
        : neu.kind === "phase"
          ? { kind: "phase" as const, phaseId: neu.phaseId }
          : // Eine frisch angelegte Aufgabe hat noch keine `id` (Risiko 7) - dann lieber keine
            // Auswahl in der Adresse als eine auf `undefined`.
            (() => {
              const taskId = String(tasks[neu.index]?.id ?? "");
              return taskId ? { kind: "task" as const, taskId } : null;
            })();
    setzeAnsicht(
      { bestellung: adresse.bestellung && { ...adresse.bestellung, tab: "tasks", aufgabe } },
      optionen,
    );
  };

  // ERST melden, wenn die Aufgaben da sind - sonst meldet jeder Tieflink einmal faelschlich,
  // waehrend die Bestellung noch laedt (dieselbe Falle wie § 5.3). `tasksGeladen` statt
  // `tasks.length === 0` (Befund W-3): eine taskleere Bestellung darf die Meldung NICHT verschlucken.
  useEffect(() => {
    if (!auswahl || auswahl.kind !== "task" || !tasksGeladen) return;
    if (ansicht !== null) return;
    // Kaputter Tieflink auf eine Aufgabe (§ 5.4): die Navigation ging ins Leere, der Nutzer erfaehrt es am Stapel
    // (Fehleranzeige Paket 1, Task 8, Klassifikation S) - nicht mehr ueber die Prop `onMeldung` und den Toast.
    meldeFehler("Die Aufgabe gehört nicht mehr zu dieser Bestellung.");
    setAnsicht(null, { ersetzen: true });
  }, [auswahl, tasks, tasksGeladen, ansicht]);

  // Siehe Kopfkommentar, "TASK_DETAIL_VIEW als lokaler State". Die vorgemerkte Id faellt mit weg -
  // sie zeigte sonst nach einem Bestellwechsel auf eine Aufgabe der VORIGEN Bestellung. `ansicht`
  // braucht diese Ruecksetzung seit Aufgabe 6 NICHT mehr: sie kommt aus der Adresse und wechselt mit
  // `kennung` ohnehin gemeinsam - ein `setAnsicht(null)` HIER wuerde stattdessen jeden Tieflink auf
  // eine Aufgabe sofort nach dem Oeffnen wieder loeschen (die Adresse ist zu diesem Zeitpunkt schon
  // auf der neuen Bestellung, dieser Effekt feuert also GENAU dann, wenn ein Tieflink `auswahl`
  // gerade erst gesetzt hat).
  useEffect(() => {
    setNeueId(null);
    // Siehe Kopfkommentar an `wirdAngewendet` oben - dieselbe Ruecksetzung wie bei `neueId`, aus
    // demselben Grund (ein Bestellwechsel darf keinen Zustand der VORIGEN Bestellung mitschleppen).
    setWirdAngewendet(false);
    // Auftrag "Tasks Sammelbearbeitung": aus demselben Grund - eine markierte Aufgabe der VORIGEN
    // Bestellung darf nach einem Bestellwechsel nicht als (zufaellig gleich indizierte) Markierung
    // der NEUEN Bestellung stehen bleiben.
    setzeAusgewaehlt(new Set());
    setzeAnker(null);
  }, [id]);

  // Siehe Kopfkommentar, "Die Zustaendigkeitsmodule laedt dieser Reiter selbst". Ein Fehlschlag
  // laesst die Liste leer - die Auswahl zeigt dann nur "Kein Modul", statt den Reiter mitzureissen -
  // und sagt das im Fehlerstapel (Regel L2: die Module haben keine eigene Flaeche). Ein Abbruch
  // (Reiter weg) und eine abgelaufene Sitzung (401) bleiben still; `meldeFehler` filtert beide selbst,
  // die Abbruch-Wache haelt zusaetzlich einen Fehlschlag nach dem Abbau aus dem Stapel.
  useEffect(() => {
    const abbruch = new AbortController();
    moduleLaden(abbruch.signal).then(
      (geladen) => setModule(geladen),
      (f: unknown) => {
        if (!abbruch.signal.aborted) meldeFehler(f, MODULE_LADEN_SATZ);
      },
    );
    return () => abbruch.abort();
  }, []);

  /** `patchTask(index, key, value, true)` (index.html:9172-9186), auf die Checkbox beschraenkt. */
  const aufgabeErledigt = (index: number, erledigt: boolean): void => {
    const bestehend = tasks[index];
    if (!bestehend) return;
    onAufgabeAendern(id, bestehend, { done: erledigt });
  };

  /**
   * Auftrag "Meilensteine (Phasen) im Tasks-Tab abhakbar machen": das Gegenstueck zu
   * `aufgabeErledigt` oben, nur fuer eine ganze Phasengruppe statt einer einzelnen Aufgabe. Reicht
   * die von `PhasenListe.tsx#TaskPhaseBlock` eingesammelten Task-IDs unveraendert an `onPhaseErledigt`
   * durch - die Bestellkennung ist hier bereits bekannt, im Unterschied zu den anderen Aufrufern
   * braucht dieser Weg keine bestehende Aufgabe zum Nachschlagen (er kennt nur ids, keine Objekte).
   */
  const phaseErledigt = (taskIds: string[], erledigt: boolean): void => {
    onPhaseErledigt(id, taskIds, erledigt);
  };

  /**
   * `patchOpenTaskDetail(key, value)` (index.html:9033-9050).
   *
   * Der Bestand hatte hier EINEN Kanal fuer beide Ansichten (Aufgabe und Phase), weil beide im
   * selben JSON-Blob landeten. Das geht nicht mehr: die Aufgabe hat eine Route, die Phase keine.
   * Der Phasen-Zweig ist deshalb ersatzlos weg statt in einen Fehlschlag zu laufen - die
   * Bedienelemente, die ihn ausloesten, sind gesperrt.
   */
  const feldAendern = (schluessel: string, wert: unknown): void => {
    if (!ansicht || ansicht.kind !== "task") return;
    const bestehend = tasks[ansicht.index];
    if (!bestehend) return;
    onAufgabeAendern(id, bestehend, { [schluessel]: wert });
  };

  /**
   * `patchTaskResponsibility` (index.html:8857-8866).
   *
   * Der Bestand schrieb hier VIER Felder (`responsibilityId`, `responsibilityName`, `assignee`,
   * `deputyAssignee` - `applyResponsibilityToTask`, lib/payments.ts). Geschrieben wird jetzt genau
   * EINES: das Modul. Hauptverantwortung und Vertretung leitet der Server daraus ab
   * (`uebertrageVerantwortung`), den Modulnamen fuehrt `responsibility_modules`. Siehe
   * `api/aufgaben.ts#KEIN_AUFGABEN_WEG`.
   */
  const aufgabeZuweisen = (modulId: string): void => {
    if (!ansicht || ansicht.kind !== "task") return;
    const bestehend = tasks[ansicht.index];
    if (!bestehend) return;
    onAufgabeAendern(id, bestehend, { responsibilityId: modulId || null });
  };

  /**
   * `addTask()` (index.html:9158-9170).
   *
   * Der Bestand oeffnet das Detail unmittelbar danach ueber `setTimeout(… o.tasks.length - 1)`, also
   * auf den Platz, an dem die Aufgabe nach dem lokalen `push` steht. Hier steht dieser Platz beim
   * Klick noch nicht fest: `sort_index` vergibt der Server, und die Liste kommt erst mit dem
   * Nachladen. Ihn zu RATEN waere der teure Fehler - der Index zeigte auf eine fremde Aufgabe, und
   * der naechste Tastendruck benaennte die um.
   *
   * Deshalb der Umweg ueber die Id: `beiErfolg` merkt sie sich, der Effekt unten schlaegt den Platz
   * nach, sobald die nachgeladene Bestellung eintrifft. Ergebnis fuer den Nutzer wie im Bestand -
   * anlegen, Fenster auf, Namen tippen -, nur eben nach dem Rundlauf statt davor.
   */
  const aufgabeHinzufuegen = (): void => {
    onAufgabeAnlegen(id, { title: NEUE_AUFGABE_TITEL }, (neu) => setNeueId((neu.id as string) || null));
  };

  /**
   * "Vorlage anwenden" - siehe `TasksTabProps.onVorlageAnwenden`. Setzt die In-Flight-Sperre
   * `wirdAngewendet` sofort und raeumt sie per `.finally()` wieder ab - `onVorlageAnwenden` loest
   * IMMER auf (nie ab), das `.finally()` reicht deshalb, ein `.catch()` waere hier ueberfluessig.
   */
  const vorlageAnwenden = (): void => {
    if (wirdAngewendet) return;
    setWirdAngewendet(true);
    onVorlageAnwenden(id).finally(() => setWirdAngewendet(false));
  };

  /**
   * Oeffnet das Detail der frisch angelegten Aufgabe, sobald sie in der Liste steht.
   *
   * `tasks` steht bewusst in der Abhaengigkeitsliste: der Effekt muss GENAU DANN erneut laufen, wenn
   * die nachgeladene Bestellung ankommt. Findet er die Id noch nicht (das Nachladen ist unterwegs
   * oder ist fehlgeschlagen), tut er nichts und behaelt die Id - beim naechsten Eintreffen greift er.
   */
  useEffect(() => {
    if (!neueId) return;
    const index = tasks.findIndex((task) => task.id === neueId);
    if (index < 0) return;
    setAnsicht({ kind: "task", index });
    setNeueId(null);
  }, [neueId, tasks]);

  /**
   * `deleteOpenTaskDetail()` (index.html:9052-9057) + `removeTask` (index.html:9188-9196) -
   * verallgemeinert auf einen BELIEBIGEN Index (Auftrag "Tasks Sammelbearbeitung"): der Bestand
   * kannte nur den Loeschknopf im Detailfenster (immer die GEOEFFNETE Aufgabe, `ansicht.index`) - der
   * neue Rechtsklick-Eintrag "Aufgabe löschen" trifft dagegen die rechtsgeklickte Zeile, die nicht
   * zwingend geoeffnet ist. `aufgabeLoeschen()` unten (der bisherige, UNVERAENDERTE Aufrufer des
   * Detail-Loeschknopfs, `AufgabenDetail.tsx#onLoeschen`) ruft diese Funktion jetzt nur noch mit
   * `ansicht.index` - beobachtbar identisches Verhalten wie vor diesem Auftrag.
   */
  const aufgabeLoeschenBeiIndex = (index: number): void => {
    const aufgabe = tasks[index];
    if (!aufgabe) return;
    if (!confirm(`Task „${(aufgabe.name as string) || "ohne Namen"}“ löschen?`)) return;
    // ERSETZEN, nicht schieben (Befund K-1, Begruendung an `setAnsicht` oben): die geloeschte
    // Aufgabe existiert nicht mehr - ein "Zurueck" auf sie waere derselbe kaputte Standpunkt wie bei
    // einem toten Tieflink, nur taeglich statt selten ausgeloest. NUR wenn die geloeschte Zeile auch
    // die GEOEFFNETE ist (Nachtrag: eine per Kontextmenue geloeschte, nicht geoeffnete Zeile lässt
    // ein offenes Detailfenster einer ANDEREN Aufgabe unangetastet).
    if (ansicht?.kind === "task" && ansicht.index === index) setAnsicht(null, { ersetzen: true });
    onAufgabeLoeschen(id, aufgabe);
  };

  /** `AufgabenDetail.tsx#onLoeschen` - unveraendertes Verhalten, siehe Kopfkommentar oben. */
  const aufgabeLoeschen = (): void => {
    if (!ansicht || ansicht.kind !== "task") return;
    aufgabeLoeschenBeiIndex(ansicht.index);
  };

  /**
   * Sammel-Loeschen (Auftrag "Tasks Sammelbearbeitung") - der Eintrag "Löschen ({N} Aufgaben)" im
   * Kontextmenue. Bestaetigt EINMAL fuer die gesamte Auswahl (Akzeptanzkriterium 6: die Anzahl im
   * Text), schliesst ein betroffenes offenes Detailfenster (dieselbe Ersetzen-Logik wie beim
   * Einzel-Loeschen) und leert die Auswahl VOR dem eigentlichen Schreibvorgang - wie `sammelStatus
   * Aendern`s Board-Pendant NACH dessen erstem erfolgreichem Schreiben, hier VOR dem Aufruf: anders
   * als beim Board (das den Server ueber `Promise` befragt, bevor es die Auswahl anfasst) gibt es
   * hier keine Zwischenlage, in der ein erneuter Rechtsklick auf eine der noch-markierten, bereits
   * zum Loeschen angestossenen Zeilen sinnvoll waere.
   */
  const aufgabenSammelLoeschen = (): void => {
    const ausgewaehlteAufgaben = tasks.filter((task) => ausgewaehlt.has(String(task.id ?? "")));
    if (!ausgewaehlteAufgaben.length) return;
    if (!confirm(`${ausgewaehlteAufgaben.length} Aufgaben löschen?`)) return;
    if (ansicht?.kind === "task" && ausgewaehlt.has(String(tasks[ansicht.index]?.id ?? ""))) {
      setAnsicht(null, { ersetzen: true });
    }
    setzeAusgewaehlt(new Set());
    setzeAnker(null);
    onAufgabenSammelLoeschen?.(id, ausgewaehlteAufgaben);
  };

  // `kontextmenue`-Zustand steht jetzt weiter oben, direkt neben `ausgewaehlt`/`anker` (siehe dessen
  // Kopfkommentar dort) - der Escape-Effekt braucht ihn frueher, als er hier stuende.

  /**
   * `openTaskContextMenu(event, index)` (index.html:8975), nachgeholt - siehe `PhasenListe.tsx`,
   * Kopfkommentar "Das Kontextmenue".
   *
   * ERWEITERUNG GEGENUEBER DEM WOERTLICHEN BOARD-VORBILD (Akzeptanzkriterium 5, "Sonst"-Zweig): ist
   * die rechtsgeklickte Zeile NICHT Teil einer Auswahl mit mindestens zwei Elementen, setzt diese
   * Funktion die Auswahl VORAB auf GENAU diese eine Zeile. Das Board tut das nirgends - dort trifft
   * "Löschen" ohnehin IMMER nur die rechtsgeklickte Zeile (nie die Auswahl, siehe `Board/KontextMenue.
   * tsx`s Kopfkommentar, "ZWEITE Erweiterung"), ein Zuruecksetzen der Auswahl waere dort wirkungslose
   * Mehrarbeit. Hier dagegen entscheidet die Auswahl SELBST, welcher der beiden Loesch-Eintraege
   * erscheint (`AufgabenKontextMenue.tsx`) - ohne dieses Zuruecksetzen bliebe eine Rechtsklick auf
   * eine UNMARKIERTE Zeile neben einer bestehenden Mehrfachauswahl mehrdeutig (traf der Klick die
   * Auswahl oder nur diese eine Zeile?).
   */
  const kontextmenueOeffnen = (ereignis: React.MouseEvent, index: number): void => {
    ereignis.preventDefault();
    const aufgabe = tasks[index];
    if (!aufgabe) return;
    const taskId = String(aufgabe.id ?? "");
    if (!(taskId && ausgewaehlt.has(taskId) && ausgewaehlt.size >= 2)) {
      setzeAusgewaehlt(taskId ? new Set([taskId]) : new Set());
      setzeAnker(taskId || null);
    }
    setKontextmenue({ aufgabe, index, x: ereignis.clientX, y: ereignis.clientY });
  };

  const kontextmenueSchliessen = (): void => setKontextmenue(null);

  /** `runOrderContextAction` (index.html:7178) fuers Tasks-Kontextmenue - nur die zwei Loeschfaelle. */
  const kontextmenueAktion = (aktion: "delete" | "bulkDelete"): void => {
    if (aktion === "bulkDelete") {
      aufgabenSammelLoeschen();
      return;
    }
    if (kontextmenue) aufgabeLoeschenBeiIndex(kontextmenue.index);
  };

  const vorlage = istVorlagenBestellung(o);
  const offen = tasks.filter((task) => !task.done).length;

  return (
    <>
      <Abschnitt schluessel="tasks-list" titel={`Tasks · ${offen} offen`}>
        {vorlage || o.taskTemplateDescription ? (
          <div className="task-template-description">
            <label>Notizen</label>
            {/*
             * BENANNTE LUECKE, laut statt still: `"taskTemplateDescription"` steht in KEINER
             * Feldgruppe (`api/bestellungen.ts#KEIN_FELDGRUPPEN_WEG`) - ein OFFENER BEFUND, weil das
             * Feld trotz seines Namens keine Vorlagenangabe ist, sondern das freie Notizfeld der
             * Bestellung im Aufgabenbereich; eine Spalte dafuer gibt es nicht - RICHTIGGESTELLT
             * (Auftrag E): `order_extras.notes` selbst ist seit Auftrag D (2026-08-22,
             * `backend/migrations/017_order_extras_warehouse_notes_entfernen.sql`) entfallen, es gibt
             * also keine Spalte mehr, die dieses Feld haette besetzen koennen.
             *
             * Seit dem 2026-08-15 SICHTBAR gesperrt statt bei jedem Tastendruck in einen Toast zu
             * laufen - dieselbe Haltung wie bei den Phasenangaben (siehe Kopfkommentar). Der
             * vorhandene Text bleibt lesbar, er ist nur nicht mehr zu aendern.
             */}
            {/*
             * Auftrag 8 (strukturell statt Sibling-Element): kein `.feld-lock-anchor`-Span mehr -
             * das Schloss-Symbol kommt seither als CSS `background-image` direkt ueber
             * `.feld-gesperrt` (`styles/neubau/feldzustand.css`), samt ausreichend `padding-right`,
             * damit auch bei langem Notizentext keine Zeile unter das Icon rutscht.
             */}
            <textarea
              placeholder="Notizen hinzufügen…"
              value={(o.taskTemplateDescription as string) || ""}
              readOnly
              aria-readonly="true"
              className={feldZustandClass({ gesperrt: true })}
              title={NOTIZEN_GESPERRT_TITEL}
              onChange={() => {}}
            />
          </div>
        ) : null}
        <PhasenListe
          bestellung={o}
          heute={heute}
          onAufgabeOeffnen={(index) => setAnsicht({ kind: "task", index })}
          onPhaseOeffnen={(phaseId) => setAnsicht({ kind: "phase", phaseId })}
          onAufgabeErledigt={aufgabeErledigt}
          onPhaseErledigt={phaseErledigt}
          ausgewaehlteIds={ausgewaehlt}
          onZeileAngeklickt={zeileAngeklickt}
          onKontextmenue={kontextmenueOeffnen}
        />
        <button className="btn-primary" type="button" onClick={aufgabeHinzufuegen}>
          <Ikone name="circle-plus" />
          Task hinzufügen
        </button>
        {/*
          Auftrag "Task-Vorlage tatsaechlich anwenden": der manuelle Anwendungsweg, gleich neben dem
          Knopf zum einzelnen Anlegen. Traegt DIESELBE Berechtigungs-Schranke wie "Task hinzufügen" -
          beide sind Bedienelemente in `.drawer-body` und haengen damit am zentralen Rechte-Durchgang
          des Rahmens (`Drawer.tsx`, an `manage_tasks` gebunden ueber `DRAWER_TAB_EDIT_PERMISSIONS`,
          `drawerRechte.ts`) - keine zweite, eigene Rechtepruefung noetig. `disabled={wirdAngewendet}`
          ist eine ZUSAETZLICHE, client-seitige In-Flight-Sperre (Review-Befund) gegen den
          Doppelklick-Fall - der Rechte-Durchgang laesst ein bereits per React gesetztes
          `disabled` unangetastet, solange die Berechtigung besteht (er ueberspringt Elemente MIT
          Berechtigung vollstaendig, siehe dortiger Kommentar).
        */}
        <button
          className="btn-ghost icon-label"
          type="button"
          onClick={vorlageAnwenden}
          disabled={wirdAngewendet}
        >
          <Ikone name="clipboard-list" />
          {wirdAngewendet ? "Wird angewendet…" : "Vorlage anwenden"}
        </button>
      </Abschnitt>
      <AufgabenDetail
        bestellung={o}
        ansicht={ansicht}
        module={module}
        phasenGesperrt={PHASEN_SCHREIBEN_GESPERRT}
        onSchliessen={() => setAnsicht(null)}
        onFeldAendern={feldAendern}
        onZuweisen={aufgabeZuweisen}
        onLoeschen={aufgabeLoeschen}
        onPhaseErledigt={phaseErledigt}
      />
      <AufgabenKontextMenue
        aufgabe={kontextmenue?.aufgabe}
        x={kontextmenue?.x ?? 0}
        y={kontextmenue?.y ?? 0}
        istInAuswahl={
          !!kontextmenue?.aufgabe?.id && ausgewaehlt.has(String(kontextmenue.aufgabe.id))
        }
        ausgewaehlteAnzahl={ausgewaehlt.size}
        onSchliessen={kontextmenueSchliessen}
        onAktion={kontextmenueAktion}
      />
    </>
  );
}
